import * as React from 'react';
import SvgIcon from 'react-native-svg-icon';

import { ColorProp } from '@lib/types';
import { StyleObj } from '@providers/Theme/types';
import { Direction, useDirection } from '@providers/Direction';
import { makeStyles, useTheme } from '@providers/Theme';

import { IconName, svgs } from './svgs';

export type IconProps = {
  name: IconName;
  size?: number;
  color?: ColorProp;
  strokeWidth?: string;
  style?: StyleObj;
  testID?: string;
  viewBoxWidth?: number;
  viewBoxHeight?: number;
};

const useStyles = makeStyles<{ direction: Direction }>({
  root: (props) => ({
    transform: props.direction === 'ltr' ? [] : [{ rotateY: '180deg' }],
  }),
});

export const Icon: React.FC<IconProps> = ({
  size = 20,
  viewBoxWidth = 24,
  viewBoxHeight = 24,
  color: colorFromProps,
  ...props
}) => {
  const { direction } = useDirection();
  const styles = useStyles({ direction });
  const theme = useTheme();
  const color =
    typeof colorFromProps === 'function'
      ? colorFromProps(theme)
      : colorFromProps ?? theme.palette.grey[700];

  const svgStyles = svgs[props.name].svgStyles(color!);

  return (
    <SvgIcon
      {...props}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      height={`${size}`}
      width={`${size}`}
      svgs={svgs}
      fill="transparent"
      {...svgStyles}
      style={[styles.root, props.style]}
    />
  );
};
